export default __webpack_public_path__ + "static/media/User Access Reporting Powered By FINOSEC.d1b79d5f.png";